// @ts-nocheck
import { IconButton, IconClose, IconMenu } from '@lmig/lmds-react-icons';
import classNames from 'classnames';
import React, { useContext, useState } from 'react';
import { useKeyPress } from '@lmig/lmds-react-date-picker/dist/useKeyPress';
import { useClickOutside } from '@lmig/lmds-react-date-picker/dist/useClickOutside';
import { FloatingHeaderContext } from '../context/FloatingHeaderContext';
import { findAncestor } from '../utils';

export interface HeaderMenuButtonProps {
  /** Toggle event on the IconButton, to toggle the menu.
   * This will be called when clicking on the `IconButton`, as well as clicking outside of the overlay, and pressing escape.
   */
  onToggle?: (event: Event) => void;
}

export const HeaderMenuButton = ({ onToggle }: HeaderMenuButtonProps): React.ReactElement => {
  // Using a callback ref rather than useRef fixes a bug: the "click outside" handler didn't fire
  // if the menu was open when the page first loaded.
  const [menuButtonElement, setMenuButtonElement] = useState<HTMLDivElement | null>(null);
  const { overlayIsOpen, showHorizontalMenu } = useContext(FloatingHeaderContext);
  const IconComponent = overlayIsOpen ? IconClose : IconMenu;
  const containerClasses = classNames('lmig-FloatingHeader-menu-button', {
    'lmig-FloatingHeader-menu-button-hidden': showHorizontalMenu,
  });

  const handleLocalClick = (event: React.MouseEvent): void => {
    onToggle(event as unknown as Event);
  };

  useClickOutside(
    findAncestor(menuButtonElement, '.lmig-FloatingHeader-inner') as HTMLElement,
    handleLocalClick,
    overlayIsOpen,
  );
  useKeyPress('Escape', onToggle, overlayIsOpen);

  return (
    <div ref={setMenuButtonElement} className={containerClasses}>
      <IconButton onClick={handleLocalClick}>
        <IconComponent size="16" />
      </IconButton>
    </div>
  );
};
